module.exports = __webpack_public_path__ + "static/media/study-groups2.2e69bcba.png";